import React, { useState } from 'react';

import Button from '../../../components/ui/Button';

const WeeklyCalendar = ({ selectedDate, onDateChange, onViewChange, currentView }) => {
  const [currentWeekStart, setCurrentWeekStart] = useState(() => {
    const date = new Date(selectedDate);
    const day = date?.getDay();
    const diff = date?.getDate() - day;
    return new Date(date.setDate(diff));
  });

  const generateWeekDays = () => {
    const days = [];
    const start = new Date(currentWeekStart);
    
    for (let i = 0; i < 7; i++) {
      const date = new Date(start);
      date?.setDate(start?.getDate() + i);
      days?.push(date);
    }
    
    return days;
  };

  const weekDays = generateWeekDays();

  const handlePreviousWeek = () => {
    const newStart = new Date(currentWeekStart);
    newStart?.setDate(currentWeekStart?.getDate() - 7);
    setCurrentWeekStart(newStart);
  };

  const handleNextWeek = () => {
    const newStart = new Date(currentWeekStart);
    newStart?.setDate(currentWeekStart?.getDate() + 7);
    setCurrentWeekStart(newStart);
  };

  const handleToday = () => {
    const today = new Date();
    const day = today?.getDay();
    const diff = today?.getDate() - day;
    const weekStart = new Date(today.setDate(diff));
    setCurrentWeekStart(weekStart);
    onDateChange(new Date());
  };

  const isToday = (date) => {
    const today = new Date();
    return date?.toDateString() === today?.toDateString();
  };

  const isSelected = (date) => {
    return date?.toDateString() === selectedDate?.toDateString();
  };

  const formatMonthYear = () => {
    const endOfWeek = new Date(currentWeekStart);
    endOfWeek?.setDate(currentWeekStart?.getDate() + 6);
    
    if (currentWeekStart?.getMonth() === endOfWeek?.getMonth()) {
      return currentWeekStart?.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    } else {
      return `${currentWeekStart?.toLocaleDateString('en-US', { month: 'short' })} - ${endOfWeek?.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}`;
    }
  };

  return (
    <div className="card">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
        <div className="flex items-center gap-4">
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
            {formatMonthYear()}
          </h2>
          <Button
            variant="outline"
            size="sm"
            onClick={handleToday}
            iconName="Calendar"
            iconPosition="left"
          >
            Today
          </Button>
        </div>

        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="icon"
              onClick={handlePreviousWeek}
              iconName="ChevronLeft"
            />
            <Button
              variant="outline"
              size="icon"
              onClick={handleNextWeek}
              iconName="ChevronRight"
            />
          </div>

          <div className="hidden md:flex items-center gap-2 border border-border rounded-lg p-1">
            <button
              onClick={() => onViewChange('week')}
              className={`px-4 py-2 rounded text-sm font-medium transition-all duration-250 ${
                currentView === 'week' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Week
            </button>
            <button
              onClick={() => onViewChange('day')}
              className={`px-4 py-2 rounded text-sm font-medium transition-all duration-250 ${
                currentView === 'day' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Day
            </button>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-2">
        {weekDays?.map((date, index) => {
          const dayName = date?.toLocaleDateString('en-US', { weekday: 'short' });
          const dayNumber = date?.getDate();
          const today = isToday(date);
          const selected = isSelected(date);

          return (
            <button
              key={index}
              onClick={() => onDateChange(date)}
              className={`
                flex flex-col items-center justify-center p-3 md:p-4 rounded-lg
                transition-all duration-250 touch-target
                ${selected
                  ? 'bg-primary text-primary-foreground shadow-md'
                  : today
                  ? 'bg-accent/10 text-accent border-2 border-accent' :'bg-muted text-foreground hover:bg-muted/80'
                }
              `}
            >
              <span className="text-xs md:text-sm font-medium mb-1">{dayName}</span>
              <span className="text-lg md:text-2xl font-heading font-semibold">{dayNumber}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default WeeklyCalendar;